// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1DCpQ","image":"Header_image__1xKRl","name":"Header_name__2NWzH","info":"Header_info__26MIS","infoRow":"Header_infoRow__2KUhn"};